import { useMemo } from "react";

import { useLocationTimezone, useTimezone } from "@/hooks/use-timezone";

import { ClinicClock, clinicClockFor } from "@/lib/clinic-clock";

/** The clinic clock, re-bound whenever the effective timezone changes. */
export function useClinicClock(): ClinicClock {
  const timeZone = useTimezone();
  return useMemo(() => clinicClockFor(timeZone), [timeZone]);
}

/** The clock of one location — an appointment's, a register's. */
export function useLocationClock(
  locationId: string | null | undefined,
): ClinicClock {
  const timeZone = useLocationTimezone(locationId);
  return useMemo(() => clinicClockFor(timeZone), [timeZone]);
}
